import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-questionnaireoutputmodal',
    templateUrl: './questionnaireoutputmodal.component.html',
    styleUrls: ['./questionnaireoutputmodal.component.scss'],
    standalone: false
})
export class QuestionnaireoutputmodalComponent implements OnInit {

  @Input() public response:any;
  @Input() public basepath:any;
  @Input() public redirecturl: any;
  // optional from webform
  @Input() public fromView?: string = '';
  @Input() public event: string = '';

  public button_disabled = false;
  public webformNavigation: any = null; // Store webform navigation data

  constructor(public router: Router, public modalController: ModalController, public navCtrl: NavController, public data: DataService, private userService: UserService) { }

  ngOnInit() {
    console.log('QuestionnaireoutputmodalComponent ngOnInit');
    console.log('this.response:', this.response);
    console.log('this.response?.output?.action:', this.response?.output?.action);
    console.log('redirectUrl:', this.redirecturl);
  }

  gotomenu(){
    this.modalController.dismiss()  
    this.router.navigateByUrl('/mainmenu',{replaceUrl: true});
  }

  closeMenu(){
    console.log('closeMenu!')
    this.modalController.dismiss()  
  }

  page(){
    let that = this
    that.button_disabled = true;
    // this.modalController.dismiss()  
    if (this.response.output.action.page) {
        switch(this.response.output.action.page) {
          case 'programonboarding':
            {
              this.data.refreshRecovery().then((response) => {
                console.log('done');
                that.button_disabled = false;
                that.router.navigate(['/programonboarding/'+that.response.output.program.id],{replaceUrl: true});
                that.modalController.dismiss();
              })
            }
            break;
          case 'inbox':
            // code block
            {
              this.data.refreshRecovery().then((response) => {
                console.log('done');
                that.button_disabled = false;
                that.router.navigate(['/'+that.response.output.action.page],{replaceUrl: true});
                that.modalController.dismiss();
              })
            }
            break;
          case 'listing':
            {
              this.data.refreshRecovery().then((response) => {
                console.log('done');
                that.button_disabled = false;
                that.router.navigate(['/treatmentshop/organisation/'+that.response.output.action.listing_id], { replaceUrl: true }) 
                // that.router.navigateByUrl('/treatmentshop/organisation/'+that.response.output.action.listing_id)
                that.modalController.dismiss()  
              })
            }
            break;
          case 'servicecategory':
            {
              this.data.refreshRecovery().then((response) => {
                console.log('done');
                that.button_disabled = false;
                // const goToCategory = () => {
                //   that.router.navigate(['/treatmentcategory/' + that.response.output.action.servicecategory_id], { replaceUrl: true });
                //   that.modalController.dismiss();
                // };
                if (that.data.services && that.data.services.listings && that.data.services.listings.length > 0) {
                  that.gotoTreatmentShop();
                } else {
                  that.data.pullAppContent(['services']).then(() => that.gotoTreatmentShop());
                }
              })
            }
            break;
          case 'webform':
            {
              this.data.refreshRecovery().then((response) => {
                console.log('done');
                that.button_disabled = false;
                
                // Use query parameters for morphTo relationship
                const navigationExtras: NavigationExtras = {
                  replaceUrl: true,
                  queryParams: {
                    type: 'action',
                    id: that.response.output.action.id,
                    questionnaire_answer_id: that.response.questionnaire_answer_id || that.response.id
                  }
                };
                
                that.router.navigate(['/webform/' + that.response.output.action.webform_id], navigationExtras);
                that.modalController.dismiss();
              })
            }
            break;
          default:
            {
              console.log('reached questionaire output modal: ', this.response.output.action.page);
              that.button_disabled = false;
              this.router.navigate(['/'+this.response.output.action.page], {replaceUrl: true})
              this.modalController.dismiss()  
            }
        }
    }
    // if(this.response.output.action.page && this.response.output.action.page == 'programonboarding')
    // {
    //   this.data.refreshRecovery().then((response) => {
    //     console.log('done')
    //     that.router.navigateByUrl('/programonboarding/'+that.response.output.program.id)
    //     that.modalController.dismiss()  
    //   })
    // }
    // else {
    //   if(this.response.output.action.page && this.response.output.action.page == 'inbox')
    //   {
    //     this.data.refreshRecovery().then((response) => {
    //       console.log('done')
    //       that.router.navigateByUrl('/'+that.response.output.action.page)
    //       that.modalController.dismiss()  
    //     })
    //   }
    //   else
    //   {
    //     this.router.navigateByUrl('/'+this.response.output.action.page)
    //     this.modalController.dismiss()  
    //   }
    // }
  }

  gotoTreatmentShop() {
    this.router.navigate(['/treatmentcategory/' + this.response.output.action.servicecategory_id], { replaceUrl: true });
    this.modalController.dismiss();
  }
  
  gotoinbox(){
    let that = this;
    that.button_disabled = true;
    this.data.refreshRecovery().then((response) => {
      // that.router.navigateByUrl('/inbox')
      that.button_disabled = false;
      that.router.navigate(['/inbox'], { replaceUrl: true });
      that.modalController.dismiss()  
    })
  }

  // Check if action has a linked webform
  hasLinkedWebform(): boolean {
    return this.response?.output?.action?.webform_id && this.response.output.action.webform_id > 0 && this.response.output.action.code === 'webform';
  }

  // Navigate to webform from action
  goToWebform(){
    let that = this;
    that.button_disabled = true;
    this.data.refreshRecovery().then((response) => {
      console.log('Navigating to webform from action');
      that.button_disabled = false;
      let qParams: any = {
        type: 'action',
        id: that.response.output.action.id,
        questionnaire_answer_id: that.response.questionnaire_answer_id || that.response.id
      }
      if (that.response.output.action.listing_id) {
        qParams.listing_id = that.response.output.action.listing_id;
      }
      
      // Use query parameters to pass morphTo data for polymorphic relationship
      const navigationExtras: NavigationExtras = {
        replaceUrl: true,
        queryParams: qParams
      };
      
      that.router.navigate(['/webform/' + that.response.output.action.webform_id], navigationExtras);
      that.modalController.dismiss();
    }).catch((error) => {
      console.error('Error navigating to webform:', error);
      that.button_disabled = false;
    })
  }

  // Continue without completing webform - go to dashboard
  continueWithoutWebform(){
    let that = this;
    console.log('continueWithoutWebform invoked');
    that.button_disabled = true;

    // Prepare request data
    const requestData = {
      letter_id: this.response?.output?.letter_id,
      questionnaire_answer_id: this.response?.questionnaire_answer_id || this.response.id,
      action_id: this.response?.output?.action?.id,
      listing_id: this.response?.output?.action?.listing_id || null
    };

    console.log('Updating letter for skipped webform:');

    try {
      // Call backend to update letter with webform completion link
      this.data.apiPostPremise('updateLetterSkippedWebform', requestData).then(async (response) => {
      console.log('updateLetterSkippedWebform response successful');

      if ((response as any) && (response as any).status === 'success') {
        // Store webform navigation data for later use
        if ((response as any).webform_navigation) {
          this.webformNavigation = (response as any).webform_navigation;
          console.log('Webform navigation data stored:', this.webformNavigation);
        }

        // Update local letters array with modified letter
        if (this.data.letters && (response as any).letter) {
          const letterIndex = this.data.letters.findIndex(l => l.id === (response as any).letter.id);
          if (letterIndex >= 0) {
            this.data.letters[letterIndex] = (response as any).letter;
            // Update storage with modified letters array
            this.data.updateLetters(this.data.letters);
            console.log('Letter updated in local array with webform link');
          }
        }

        // Prefer server-provided full letters list if available (snake_case or camelCase)
        if (Array.from((response as any)?.all_letters || []).length > 0) {
          this.data.updateLetters((response as any).all_letters);
          console.log('Replaced local letters with response.all_letters to refresh UI');
        }
      }

      this.data.apiPostPremise('letters', { refresh: true }).then((lettersResponse) => {
        if ((lettersResponse as any) && Array.isArray((lettersResponse as any).items)) {
          this.data.updateLetters((lettersResponse as any).items);
          console.log('Letters refreshed from server after skipping webform');
        }
      }).catch((lettersError) => {
        console.error('Error refreshing letters after skipping webform:', lettersError);
      });

      await this.data.refreshRecovery();
      console.log('Continuing without completing webform');
      that.button_disabled = false;
      this.performNavigation(true);
    });
      
    } catch (error) {
      console.error('Error updating letter for skipped webform:', error);
      // Continue with normal flow even if letter update fails
      try {
        this.data.refreshRecovery().then(() => {
          console.log('Continuing without completing webform (letter update failed)');
          that.button_disabled = false;
          this.performNavigation(true);
        });
      } catch (recoveryError) {
        console.error('Error continuing without webform:', recoveryError);
      }
      that.button_disabled = false;
    }
    
  }

  // Helper method to perform navigation after processing
  private performNavigation(skippedWebform: boolean = false) {
    const navigationExtras = {
      replaceUrl: true,
      state: { fromQuestionnaire: true, skippedWebform }
    };

    if (this.redirecturl) {
      this.router.navigateByUrl(this.redirecturl, { replaceUrl: true });
    } else {
      if (this.data.progress == undefined || this.data.progress.code == undefined) {
        this.router.navigateByUrl('/feedbackinput', { replaceUrl: true });
      } else {
        this.router.navigate(['/home'], navigationExtras);
      }
    }
    this.modalController.dismiss();
  }

  // Debug wrapper for the template button to trace click events
  onContinueClicked(event: Event) {
    console.log('onContinueClicked invoked', { eventType: event?.type, button_disabled: this.button_disabled, response: this.response });
    // Prevent default handling if button is disabled
    if (this.button_disabled) {
      console.warn('Button click ignored because button_disabled is true');
      return;
    }
    try {
      // Call the actual handler
      this.continueWithoutWebform();
    } catch (err) {
      console.error('onContinueClicked forwarding error:', err);
    }
  }

  validPhone(){
    if(this.response.output.action.phone == '[GP_PHONE]' && this.data.user.gp_phone){
      return this.data.user.gp_phone;
    }

    if(this.response.output.action.phone){
      return this.response.output.action.phone;
    }

    return false;
  }

  ok(){
    let that = this;
    that.button_disabled = true;
    this.data.showAjaxRequestLoader = true;
    // Hide the questionnaire underneath synchronously, before navigating. The Android
    // WebView commits the router swap a frame late, so without this the form is briefly
    // exposed when the modal dismisses; hiding it means there is nothing left to expose.
    this.data.exitingQuestionnaire = true;

    this.data.refreshRecovery().then(async function(){
      that.data.showAjaxRequestLoader = false;
      const page = that.fromView;

      let stateProps: any = {};

      if (!!page) {
        // adding props
        switch(page) {
          case 'webform':
            stateProps.fromWebform = true; // add fromWebform flag to indicate navigation from webform
            break;
          // can add more cases here for different fromView values if needed
        }

        stateProps.pageLocated = page; // add fromWebform flag to indicate navigation from webform
      } else {
        stateProps.fromQuestionnaire = true;
      }

      const hasRedFlagLockout = !!(that.response?.output?.action?.locked);
      const fromWebform = that.fromView === 'webform';
      const useBookDtrsRedirect = that.event === 'book_dtrs' && that.redirecturl && (!hasRedFlagLockout || fromWebform);

      if (useBookDtrsRedirect) {
        // Extract webform_id from redirectUrl (format: /webform/{id}?...)
        const match = that.redirecturl.match(/\/webform\/(\d+)/);
        if (match && match[1]) {
          const webformId = parseInt(match[1], 10);
          // Parse query params from redirectUrl
          const queryString = that.redirecturl.split('?')[1] || '';
          const queryParams: any = {};
          queryString.split('&').forEach(param => {
            const [key, value] = param.split('=');
            if (key) queryParams[key] = value || '';
          });
          that.data.setWebformDraftStatus(webformId, 'completing', queryParams);
        }
      }

      await that.navigateAfterQuestionnaire(useBookDtrsRedirect, stateProps);
      that.button_disabled = false;
      that.modalController.dismiss();
    }).catch(async function(){
      that.data.showAjaxRequestLoader = false;

      const hasRedFlagLockout = !!(that.response?.output?.action?.locked);
      const fromWebform = that.fromView === 'webform';
      const useBookDtrsRedirect = that.event === 'book_dtrs' && that.redirecturl && (!hasRedFlagLockout || fromWebform);

      await that.navigateAfterQuestionnaire(useBookDtrsRedirect, { fromQuestionnaire: true });
      that.button_disabled = false;
      that.modalController.dismiss();
    })
  }

  private async navigateAfterQuestionnaire(useBookDtrsRedirect: boolean, stateProps: any) {
    if (useBookDtrsRedirect) {
      await this.navCtrl.navigateForward(this.redirecturl, { replaceUrl: true, animated: false });
    } else {
      const options = { replaceUrl: true, animated: false, state: stateProps };
      if (this.data.progress == undefined || this.data.progress.code == undefined) {
        await this.navCtrl.navigateRoot('/feedbackinput', options);
      } else {
        await this.navCtrl.navigateRoot('/home', options);
      }
    }

    // The Android WebView commits the router outlet swap on a later frame, so the
    // caller must wait for the destination to actually paint before dismissing the
    // modal; otherwise the questionnaire underneath is briefly exposed.
    await new Promise<void>(resolve =>
      requestAnimationFrame(() => requestAnimationFrame(() => resolve()))
    );
  }

  call(){
    window.open('tel:' + this.validPhone());
  }
}
